<template>
	<div style="width: 100%;height: 100%;background: #eceef1;">
		<Layout-Top menuName="更多" prevUrl="/WeChat/Person/Info">
		</Layout-Top>
		<Row type="flex" justify="center" align="center" style="height: 56px;width: 100%; background: #f8f8f9;line-height: 56px;margin-bottom: 1px;">
			<Col span="6" style="padding-left: 16px;">
				性别
			</Col>
			<Col span="16" style="text-align: right;">
				男
			</Col>
			<Col span="2">
			</Col>
		</Row>
		<div @click="birthdayShow=true">
			<Row type="flex" justify="center" align="center" style="height: 56px;width: 100%; background: #f8f8f9;line-height: 56px;">
				<Col span="6" style="padding-left: 16px;">
					生日
				</Col>
				<Col span="16" style="text-align: right;">
					{{person.pbirthday}}
				</Col>
				<Col span="2">
					<Icon style="margin-top: -2px;" size="28" type="ios-arrow-forward" />
				</Col>
			</Row>
		</div>
		<Modal
			v-model="birthdayShow"
			:mask-closable="false"
			:footer-hide="true">
			<div slot="header" style="text-align: center;font-size: 18px;">
				修改出生日期
			</div>
			<Row type="flex" justify="center" align="center" style="height: 30px;">
				<Col span="8">
				</Col>
				<Col span="8" style="text-align: center;">
					<img src="../../../../../../assets/image/birthday.png" />
				</Col>
				<Col span="8">
				</Col>
			</Row>
			<Row type="flex" justify="center" align="center" style="margin-bottom: 16px;">
				<Col span="5">
				</Col>
				<Col span="12" style="text-align: center;">
					<DatePicker v-model="pbirthday" format="yyyy-MM-dd" :clearable="false" type="date" style="width: 120px;"></DatePicker>
				</Col>
				<Col span="5">
				</Col>
			</Row>
			<Row type="flex" justify="center" align="center">
				<Col span="8">
				</Col>
				<Col span="8" style="text-align: center;">
					<Button type="text" long style="outline: none;box-shadow:none;">修改</Button>
				</Col>
				<Col span="8">
				</Col>
			</Row>
		</Modal>
	</div>
</template>
<script>
	import Top from '../../assembly'
	export default {
		components: {
			'Layout-Top': Top
		},
		data(){
			return {
				birthdayShow:false,
				person:{
					pbirthday:'1996-10-22'
				},
				pbirthday:new Date('1996-10-22')
			}
		}
	}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/views/WeChat/Person/Info/More/index.vue